import React, { useContext, useState } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { sizeIconMap } from './consts.js';
import DropdownButton from '../../components/DropdownButton/DropdownButton.js';
import '../../icons/SizeContentIcon.js';
import '../../icons/SizeSmallIcon.js';
import '../../icons/SizeOriginalIcon.js';
import '../../icons/SizeFullWidthIcon.js';
import '../../components/ToolbarButton/ToolbarButton.js';
import 'classnames';
import '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../../icons/DropdownArrowIcon.js';

const NodeSizeButton = ({ toolbarItem, dataHook, id }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext) || {};
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedSize = () => (toolbarItem == null ? void 0 : toolbarItem.attributes.nodeSize) || "CONTENT";
  const selectedSize = getSelectedSize();
  const SelectedSizeIcon = sizeIconMap[`${selectedSize}`];
  const closeModal = () => modalService.closeModal(id);
  const onSizeClick = (size) => {
    var _a;
    (_a = toolbarItem.commands) == null ? void 0 : _a.setSize({ value: size });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService == null ? void 0 : modalService.openModal(id, {
      componentProps: {
        getSelectedSize,
        onClick: onSizeClick
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: modalService.isModalOpen(id),
      onClick,
      setRef: setReferenceElement,
      Icon: SelectedSizeIcon,
      tooltip: t("ButtonModal_Size_Section")
    }
  );
};

export { NodeSizeButton as default };
//# sourceMappingURL=NodeSizeButton.js.map
